import React from 'react';
import Settings from '../AddressComplete/Settings.jsx'
import ComingSoon from './ComingSoon';
import { useEffect } from "react";

const ProfileSettings = () => {
  useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
  return <Settings/>;
};

export default ProfileSettings;
